import React from 'react';
import { useParams, Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getSundargarhRuleById } from '../config/sundargarhRules';
import { getCategoryById } from '../config/categories';
import ComingSoon from '../shared/ComingSoon';
import SundargarhMemberMatch from './sundargarh/SundargarhMemberMatch';
import SundargarhSchoolCount from './sundargarh/SundargarhSchoolCount';
import SundargarhAnganwadi from './sundargarh/SundargarhAnganwadi';
import SundargarhSubhadra from './sundargarh/SundargarhSubhadra';
import SundargarhIndicators from './sundargarh/SundargarhIndicators';
import SundargarhGenderRoster from './sundargarh/SundargarhGenderRoster';
import SundargarhDuplicateMember from './sundargarh/SundargarhDuplicateMember';
import SundargarhHealthInsurance from './sundargarh/SundargarhHealthInsurance';
import SundargarhAgeEducation from './sundargarh/SundargarhAgeEducation';
import SundargarhMultiSpouse from './sundargarh/SundargarhMultiSpouse';
import SundargarhRoster from './sundargarh/SundargarhRoster';
import SundargarhSmallHouseholds from './sundargarh/SundargarhSmallHouseholds';

// Sundargarh counterpart of RulePage.js. Maps an enabled rule's `component`
// to its live-KoboToolbox screen.
const COMPONENTS = {
  memberMatch: SundargarhMemberMatch,
  schoolCount: SundargarhSchoolCount,
  anganwadi: SundargarhAnganwadi,
  subhadra: SundargarhSubhadra,
  indicators: SundargarhIndicators,
  genderRoster: SundargarhGenderRoster,
  duplicateMember: SundargarhDuplicateMember,
  healthInsurance: SundargarhHealthInsurance,
  ageEducation: SundargarhAgeEducation,
  multiSpouse: SundargarhMultiSpouse,
  roster: SundargarhRoster,
  smallHouseholds: SundargarhSmallHouseholds,
};

export default function SundargarhRulePage() {
  const { id } = useParams();
  const rule = getSundargarhRuleById(id);

  if (!rule) {
    return (
      <div className="page">
        <ComingSoon title="Unknown rule" description="This validation rule does not exist." />
      </div>
    );
  }

  if (!rule.enabled) {
    const category = getCategoryById(rule.category);
    return (
      <div className="page">
        {category ? (
          <Link to={`/sundargarh-category/${category.id}`} className="back-link">
            <ArrowBackIcon fontSize="small" /> Back to {category.label}
          </Link>
        ) : null}
        <ComingSoon
          title={rule.title}
          description="This validation rule isn't computable from the live KoboToolbox data this form collects (see the Sundargarh Validation Rules notes) or is planned but not yet available."
        />
      </div>
    );
  }

  const Comp = COMPONENTS[rule.component];
  return Comp ? <Comp rule={rule} /> : <ComingSoon title={rule.title} />;
}
